import React from 'react';
import { ArrowRight } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="about" className="py-32 relative" style={{ backgroundColor: '#1a1a1a' }}>
      <div className="container mx-auto px-8">
        <div className="grid md:grid-cols-2 gap-16 lg:gap-24 items-center max-w-6xl mx-auto">
          {/* Left - Title */}
          <div>
            <p 
              className="text-xs tracking-[0.3em] mb-6 font-light"
              style={{ color: '#8b7355' }}
            >
              CHAPTER ONE
            </p>
            <h2 
              className="text-3xl md:text-4xl lg:text-5xl font-light leading-tight"
              style={{ fontFamily: "'Playfair Display', serif", color: '#ffffff' }}
            >
              DIGITAL MARKETING
              <br />
              <span className="italic" style={{ color: '#8b7355' }}>changed everything</span>
              <br />
              FOR ME
            </h2>
          </div>
          
          {/* Right - Content */}
          <div className="space-y-6">
            <p 
              className="text-3xl md:text-4xl font-light italic mb-8"
              style={{ fontFamily: "'Playfair Display', serif", color: '#8b7355' }}
            >
              hey! i'm farzeen 👋
            </p>
            
            <p className="text-base font-light leading-relaxed" style={{ color: 'rgba(255,255,255,0.8)' }}>
              I help women <span className="italic" style={{ color: '#8b7355' }}>break free & build</span> online income with confidence. Whether you're starting from scratch or ready to elevate your digital presence, I'll guide you every step of the way.
            </p>
            
            <p className="text-base font-light leading-relaxed" style={{ color: 'rgba(255,255,255,0.8)' }}>
              Digital marketing gave me something I was searching for — clarity, control, and freedom. What started as learning how to build online income became a way to design life on my terms.
            </p>
            
            <p className="text-base font-light leading-relaxed" style={{ color: 'rgba(255,255,255,0.8)' }}>
              Today, I combine proven <span className="italic" style={{ color: '#8b7355' }}>Digital Wealth Academy</span> strategies with personalized branding and strategic marketing guidance — so women can build freedom-based businesses that actually fit their lives.
            </p>
            
            <a 
              href="#services"
              className="inline-flex items-center gap-2 text-xs tracking-[0.2em] font-light mt-6 transition-opacity hover:opacity-60"
              style={{ color: '#8b7355' }}
            >
              LET'S WORK TOGETHER
              <ArrowRight size={14} strokeWidth={1.5} />
            </a>
          </div>
        </div>
        
        {/* Stats Row */}
        <div className="grid grid-cols-3 gap-8 max-w-3xl mx-auto mt-24 pt-16 border-t" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-light mb-2" style={{ color: '#ffffff' }}>1:1</div>
            <div className="text-xs tracking-[0.2em] font-light" style={{ color: '#8b7355' }}>MENTORSHIP</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-light mb-2" style={{ color: '#ffffff' }}>DWA</div>
            <div className="text-xs tracking-[0.2em] font-light" style={{ color: '#8b7355' }}>CERTIFIED</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-light mb-2" style={{ color: '#ffffff' }}>100%</div>
            <div className="text-xs tracking-[0.2em] font-light" style={{ color: '#8b7355' }}>SUPPORT</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
